import { useSelector } from 'react-redux'
import { RootState } from '../store'

export const useAssetsStore = () => {
  const { list: assets, loading, loaded, error, selectedAssetId } = useSelector(
    (state: RootState) => state.assets
  )

  // Plain functions — no useMemo
  const getAssetById = (id: string | number) => {
    const idStr = id.toString()
    return assets.find(asset => asset.id.toString() === idStr) || null
  }

  const getAssetsByIds = (ids: (string | number)[]) => {
    const idStrings = ids.map(id => id.toString())
    return assets.filter(asset => idStrings.includes(asset.id.toString()))
  }

  const getAssetsByType = (typeId: number) => {
    return assets.filter(asset => asset.assetTypeId === typeId)
  }

  const getChildAssets = (parentId: number) => {
    return assets.filter(asset => asset.parentId === parentId)
  }

  const getRootAssets = assets.filter(asset => !asset.parentId)

  const selectedAsset =
    selectedAssetId != null ? getAssetById(selectedAssetId) : null

  return {
    assets,
    loading,
    loaded,
    error,
    selectedAssetId,
    selectedAsset,

    getAssetById,
    getAssetsByIds,
    getAssetsByType,
    getChildAssets,
    getRootAssets,

    totalCount: assets.length,
    isEmpty: assets.length === 0,
  }
}
